export default __webpack_public_path__ + "static/waves-purple-f898c035c192e4f0a9132b5a126deb34.jpg";